import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

export interface ICellProps {
  align?: 'center' | 'left' | 'right';
  fontSize?: 'default' | 'small' | 'large';
  fontWeight?: 'semiBold' | 'bold';
  maxWidth?: number;
  minWidth?: number;
  onClick?: any;
  type?: 'actions' | 'default';
  verticalAlign?: 'top' | 'center' | 'bottom';
  wrapText?: boolean;
  color?: string;
}

export const Cell = styled.td<ICellProps>`
  position: relative;
  width: auto;
  height: ${toRem(theme.table.cell.height)};
  margin-bottom: 0;
  padding: 0 ${toRem(theme.space.xl)};
  vertical-align: middle;
  white-space: nowrap;
  border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};

  &::before {
    display: none;
  }

  strong {
    font-weight: ${theme.font.weight.semiBold};
  }

  ${({ verticalAlign }) =>
    verticalAlign === 'top' &&
    css`
      justify-content: flex-start;
      vertical-align: top;
    `}

  ${({ verticalAlign }) =>
    verticalAlign === 'bottom' &&
    css`
      justify-content: flex-end;
      vertical-align: bottom;
    `}

  ${({ align }) =>
    align === 'center' &&
    css`
      @media (min-width: ${theme.breakpoint.med}px) {
        text-align: center;

        > * {
          margin: 0 auto;
        }
      }
    `}

  ${({ align }) =>
    align === 'right' &&
    css`
      text-align: right;

      > * {
        margin: 0 0 0 auto;
      }
    `}

  ${({ fontSize }) =>
    fontSize === 'large' &&
    css`
      @media (min-width: ${theme.breakpoint.med}px) {
        font-weight: ${theme.font.weight.semiBold};
        font-size: ${toRem(theme.font.size.lg)};
      }
    `}

  ${({ fontSize }) =>
    fontSize === 'small' &&
    css`
      font-size: ${toRem(theme.font.size.xs)};
    `}

  ${({ fontWeight }) =>
    fontWeight &&
    css`
      font-weight: ${theme.font.weight[fontWeight]};
    `}

  ${({ minWidth }) =>
    minWidth &&
    css`
      && {
        min-width: ${toRem(minWidth)};
      }
    `}

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      && {
        max-width: ${toRem(maxWidth)};
      }
    `}

  ${({ type }) =>
    type === 'actions' &&
    css`
      position: absolute;
      top: ${toRem(15)};
      right: ${toRem(11)};
      width: ${toRem(33)};
      height: ${toRem(33)};

      @media (min-width: ${theme.breakpoint.med}px) {
        position: relative;
        top: auto;
        right: auto;
      }
    `}

  ${({ wrapText }) =>
    wrapText &&
    css`
      white-space: pre-wrap !important;
      word-break: break-word !important;
    `}

  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;
